import { createFileRoute } from "@tanstack/react-router";
import SiteServices from "@/pages/site/SiteServices";
import { serviceCategoriesData, servicesData } from "@/data/site/services";
import { siteConfig } from "@/config/siteConfig";

const url = `${siteConfig.url}/services`;
const title = "Tax Attorney Services | IRS Help | McCauley Law";
const desc =
  "Tax attorneys for IRS audits, Offers in Compromise, liens, levies, payroll tax, FBAR & criminal tax defense. 30+ years experience.";

const itemListLd = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Tax Attorney Services",
  itemListElement: servicesData.map((svc, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: svc.title,
    url: `${siteConfig.url}/services/${svc.category}/${svc.slug}`,
  })),
};

const breadcrumbLd = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: siteConfig.url },
    { "@type": "ListItem", position: 2, name: "Services", item: url },
  ],
};

const collectionLd = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: title,
  description: desc,
  url,
  about: serviceCategoriesData.map((c) => ({
    "@type": "Thing",
    name: c.title,
    url: `${siteConfig.url}/services/${c.slug}`,
  })),
};

// The firm itself is declared once site-wide as https://mlotax.com/#organization
// (see src/routes/__root.tsx). Never re-declare it inline here.

export const Route = createFileRoute("/_site/services/")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: desc },
      { name: "robots", content: "index, follow" },
      { property: "og:title", content: title },
      { property: "og:description", content: desc },
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { property: "og:site_name", content: siteConfig.name },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: desc },
    ],
    links: [{ rel: "canonical", href: url }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbLd) },
      { type: "application/ld+json", children: JSON.stringify(collectionLd) },
      ...(itemListLd.itemListElement.length > 0
        ? [{ type: "application/ld+json", children: JSON.stringify(itemListLd) }]
        : []),
    ],
  }),
  component: SiteServices,
});
